module.exports = __webpack_public_path__ + "assets/img/6_518_big.f32aed01.jpg";